import {FC} from 'react'
import Button from "../Button/Button";
import {bookingFlows, settings} from "../../../constants/global";

interface Props {
    booking: Booking,
    setBooking:Function
}

const TireShopOpen: FC<Props> = ({ booking, setBooking}) => {
    const open = () => {
        booking.modal = 5
        setBooking({
            ...booking,
        })
    }

    if(!settings.tire_shop)
        return

    return (
        <>
            <div className={'mt-5 text-content'} style={{marginBottom:'50px'}}>
                <h3 className="">Mechanums däckshop</h3>
                <p>I vår däckshop kan du lägga till däck till din bokning.</p>
                <Button id={'btn-open-tire-shop'} className={'btn btn-center btn--skyblue'} title={'Öppna däckshop'} action={open} active={true} />
            </div>
        </>
    )
}

export default TireShopOpen